import { initReactI18next } from "react-i18next";

import { getPageProps } from "@/utils/pageProps";
import i18next from "i18next";
import Backend from "i18next-http-backend";

const pageProps = getPageProps() as unknown as { appVersion: string };

const i18nConfig: { [key: string]: unknown } = {
    fallbackLng: "en",
    // English is the only supported locale. Any other language set on the
    // user (e.g. a legacy "vi" preference) resolves to English.
    supportedLngs: ["en"],
    // Suppress the Locize marketing banner that i18next 25+ prints to
    // console.info on every init.  It's a no-op for functionality — just
    // removes noise from CI test output (70+ lines per shard).
    showSupportNotice: false,
    interpolation: {
        escapeValue: false
    },
    react: {
        wait: true,
        useSuspense: false
    }
};

i18nConfig.backend = {
    loadPath: `${process.env.ASSET_URL}/build/locale/{{lng}}.json?v=${
        pageProps?.appVersion ?? ""
    }`
};

/**
 * i18next-http-backend plugin is used to fetch the language bundles asynchrnously
 */
i18next
    .use(Backend)
    .use(initReactI18next)
    .init(i18nConfig);

export { i18next };
